import { useTheme } from "./useTheme";

const useIsDarkMode = () => {
  const { theme } = useTheme();

  if (theme === "system") {
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  return theme === "dark";
};

export { useIsDarkMode };
